import module from 'viaticos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class ViaticosSharedComprobantesAgregarComponent {
  catalogos
  idProyecto
  idColaborador
  viaticoId
  operadora
  onClose
  onChange
  data = []
  errores = []
  guardando = false
  opcion = null
  permiteGuardar = false
  validos = []
  viaje

  constructor ($q, ViaticosSolicitudComprobacionService) {
    this.$q = $q
    this.ViaticosSolicitudComprobacionService = ViaticosSolicitudComprobacionService
  }

  agregarComprobantes (data) {
    this.opcion = null

    if (!data.length) return

    if (this.data.length) {
      data.forEach((item) => {
        const existe = this.validos.some((elemento) => !item.errores && (elemento.data.uuid && elemento.data.uuid === item.data.uuid))
        if (existe) {
          item.errores = 1
          item.mensajes.push({estatus: 3, mensaje: 'El tipo de comprobante esta duplicado'})
        }
      })
    }

    this.data = [...this.data, ...data]
    this.errores = this.data.filter((item) => item.errores)
    this.validos = this.data.filter((item) => !item.errores)
    this.validar()
  }

  guardar () {
    if (this.guardando) return

    this.guardando = true

    let data = {
      viaje: this.viaje,
      comprobantes: this.validos,
    }

    this.ViaticosSolicitudComprobacionService.post(this.idProyecto, this.idColaborador, data, this.viaticoId)
      .then(({data}) => {
        this.guardando = false
        this.onChange({$event: {detail: data}})
      })
  }

  actualizar (data, valido) {
    this.validos = valido ? [...data] : this.validos
    this.errores = !valido ? [...data] : this.errores
    this.data = [...this.errores, ...this.validos]
    this.validar()
  }

  validar () {
    this.data = orderBy(this.data, '-data.id_categoria')
    this.permiteGuardar = !!this.validos.length && this.validos.every((item) => !!item.data.id_categoria)
  }

  cancelar () {
    if (this.guardando) return

    this.onClose()
  }
}

module.component('viaticosSharedComprobantesAgregar', {
  controller: ViaticosSharedComprobantesAgregarComponent,
  template,
  bindings: {
    catalogos: '<',
    idColaborador: '<',
    idProyecto: '<',
    viaticoId: '<',
    viaje: '<',
    operadora: '<',
    onClose: '&',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/comprobantes/agregar/component.js